<template>
  <div class="illustration-summary-content" id="identidade-visual-ilustracao-resumo" data-search-anchor>
    <div class="illustration-summary-wrapper">
      <h1 class="illustration-summary-title-span">{{ summaryTitleSpan }}</h1>
      <h1 class="illustration-summary-title">{{ summaryTitle }}</h1>
    </div>

    <div class="description-illustration-summary-wrapper">
      <div class="illustration-summary-icon-wrapper1">
        <p class="illustration-summary-description">{{ summaryDescription1 }}</p>
      </div>

      <div class="illustration-summary-icon-wrapper-importante">
        <p class="importante" style="margin-bottom: 0;">{{ summaryDescription3 }}</p>
        <div class="illustration-importante">
          <IconCheck />
          <p class="illustration-summary-description-icon4">{{ summaryDescription4 }}</p>
        </div>
      </div>

      <div class="illustration-summary-icon-wrapper">
        <p class="illustration-summary-description">{{ summaryDescription2 }}</p>
      </div>
    </div>

    <div
      class="illustration-summary-card-item"
      :style="{ backgroundImage: `url(${ImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class IllustrationSummarySection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  get summaryTitleSpan(): string {
    return this.getElementTitle(10, 0)
  }

  get summaryTitle(): string {
    return this.getElementText(10, 0)
  }

  get summaryDescription1(): string {
    return this.getElementText(10, 1)
  }

  get summaryDescription2(): string {
    return this.getElementText(10, 2)
  }

  get summaryDescription3(): string {
    return this.getElementText(10, 3)
  }

  get summaryDescription4(): string {
    return this.getElementText(10, 4)
  }

  get ImageSrc(): string {
    return this.getElementMedia(10, 5)
  }  

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
  }
}
</script>

<style lang="scss">
.illustration-summary-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.illustration-summary-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.illustration-summary-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.illustration-summary-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-illustration-summary-wrapper { 
  position: relative;
  
  display: grid;
  grid-template-columns: 50% 50%;  
}


.illustration-summary-icon-wrapper1 {
  display: flex;  
}

.illustration-summary-icon-wrapper {
  display: flex;
  align-items: center;
}

.illustration-summary-description,
.importante,
.illustration-summary-description-icon4 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  width: 430px;
}

.illustration-summary-description,
.importante {
  margin-top: 0;   
}



.illustration-summary-description-icon4 {
  padding-left: 7px;
  width: 378px;  
}

.illustration-summary-card-item {
  position: relative;
  bottom: 0;  

  max-width: 1032px;
  width: 100%;
  height: 1200px;  

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.illustration-summary-icon-wrapper-importante{
  display: flex;
  flex-direction: column;
}

.illustration-importante{
  display: flex;
  align-items: center
}
</style>
